

class Youtube {
    constructor(key){
        this.key=key;
        this.getRequestOptions = {
            method: 'GET',
            redirect: 'follow'
            };
    }

    async mostPopular(){
        const response = await fetch(
            `https://youtube.googleapis.com/youtube/v3/videos?maxResults=25&part=snippet&chart=mostPopular&regionCode=kr&key=${this.key}`,
            this.getRequestOptions
        );
        const result = await response.json();
        return result.items;
        };

    async search(query){
        const response = await fetch(
            `https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&q=${query}s&type=video&key=${this.key}`,
            this.getRequestOptions
        );
        const result = await response.json();
        return result.items.map(item =>({...item, id:item.id.videoId}));
        };
}

export default Youtube;
